const getDisplayName = component =>
  component.displayName || component.name || 'Unknown';

export default getDisplayName;
